module.exports = __webpack_public_path__ + "img/Group 1355.19ed39f1.svg";